import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';




export function getTagListSuccess(tag) {
  return {type: types.LOAD_TAG_LIST_SUCCESS, tag};
}



export function getTagList(pagina, regitrosPorPagina, filtro, showActivos,filtrosCombo, token ) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().TagApi.getTagList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ).then(tag => {                  
                   
                  dispatch(getTagListSuccess(tag));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getTagSuccess(catalogo) {
  return {type: types.LOAD_TAG_SUCCESS, catalogo};
}

export function getTag(id, token ) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().TagApi.getTag(id, token ).then(tag => {   
        dispatch(getTagSuccess(tag));
        return tag;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(tag) {
  return {type: types.SAVE_TAG_SUCCESS, tag};
}


export function save(tag, token ) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().TagApi.save(tag, token ).then(tagGuardado => {   
    dispatch(saveSuccess(tagGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getTagComboSuccess(datos) {
  return {type: types.GET_TAGS_COMBO_SUCCESS, datos};
}

export function getTagCombo(token ) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().TagApi.getTagCombo( token ).then(datos => {   
        
      dispatch(getTagComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(tag) {
  return {type: types.BORRAR_TAG_SUCCESS, tag};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().TagApi.borrar(id, token ).then(tag => {
               
                  dispatch(borrarSuccess(tag));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(tag) {
  return {type: types.ACTIVAR_TAG_SUCCESS, tag};
}


export function activar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().TagApi.activar(id, token ).then(tag => {
               
                  dispatch(activarSuccess(tag));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_TAG, filtro};
}



